import { usePeopleManagementApi } from 'infrastructure/api';
import { DocumentStorageContextData } from 'framework/documentStorage';
import { LoadingParams } from 'framework/list';
import { FormFieldsData } from 'framework/form';
import useDocumentStorageReceiver from './useDocumentStorageReceiver';
import { normalizeStoragePath } from './documentStorageService';

const useTemplateDocumentStorageService = (): DocumentStorageContextData => {
  const { sendPostRequest } = usePeopleManagementApi();
  const searchDocuments = async (requestParams: LoadingParams) => {
    try {
      const request = await sendPostRequest('/documents/search', requestParams);
      return request.json();
    } catch {
      return {
        result: [],
      };
    }
  };

  const getDocumentByPaths = useDocumentStorageReceiver(async (paths: string[]) => {
    const request = await sendPostRequest('/documents/files', {
      paths,
    });
    const response = await request.json();
    return response.result || [];
  });

  const uploadDocument = async (data: FormFieldsData) => {
    const request = await sendPostRequest('/document/commit', data);
    return request.json();
  };

  const editDocument = async (data: FormFieldsData) => {
    const request = await sendPostRequest('/document/commit', data);
    return request.json();
  };

  const getDocumentToken = async (path: string) => {
    const request = await sendPostRequest('/document/token', {
      path: normalizeStoragePath(path),
    });
    const response = await request.json();
    return response.metadata?.preSignedUrl || '';
  };

  const getValidationSchema = () => Promise.resolve({});

  return {
    searchDocuments,
    getDocumentByPaths,
    uploadDocument,
    editDocument,
    getDocumentToken,
    getValidationSchema,
  };
};

export default useTemplateDocumentStorageService;
